<!-- =========================================================================================
  File Name: UserList.vue
  Description: Integration Users List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <module-actions-form action="add" />
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { setApplicationLocalStorageItem, performFetch } from '../../helpers'
import ModuleActionsForm from './ModuleActionsForm.vue'

export default {
  components: {
    vSelect,
    ModuleActionsForm
  },
  data: () => ({
    selectedRows: [],
  }),
  watch: {
    selectedRows(value) {
      // console.log(value)
    },

  },
  mounted() {
    document.querySelector('.vx-card').style.backgroundColor = '#fff'
    document.title = `${document.title.split(' | ')[0]} | Usuários de Integração`
  },
  methods: {
    onSelectClick() {

      if (!this.showBlankContent) {

        try {
          const offsetHeight = document.querySelector('.vs__dropdown-menu').offsetHeight

          document.querySelector('#blank_content').style.height = offsetHeight + 'px'

          this.showBlankContent = true
        } catch (e) {
          //
        }
      }
    },
    onSelectEditClick() {

      if (!this.showBlankContentEdit) {

        try {
          const offsetHeight = document.querySelector('.vs__dropdown-menu').offsetHeight

          document.querySelector('#blank_content_edit').style.height = offsetHeight + 'px'

          this.showBlankContentEdit = true
        } catch (e) {
          //
        }
      }
    },
    handleSearch(searching) {
      console.log(`The user searched for: ${searching}`)
    },
    handleChangePage(page) {
      console.log(`The user changed the page to: ${page}`)
    },
    handleSort(key, active) {
      console.log(`the user ordered: ${key} ${active}`)
    },
    clearAddForm() {
      this.addIntegrationUserData.name = ''
      this.addIntegrationUserData.role = {}
    },
    clearEditForm() {
      this.editIntegrationUserData.name = ''
      this.editIntegrationUserData.role = {}
    },
    validateAddForm() {
      if (this.addIntegrationUserData.name === '' || this.addIntegrationUserData.name === null) {
        this.$vs.notify({
          title: this.$t('USER_INTEGRATION.attention'),
          text: this.$t('USER_INTEGRATION.fieldRequired', { field: this.$t('USER_INTEGRATION.name') }),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }

      if (JSON.stringify(this.addIntegrationUserData.role) === '{}') {
        this.$vs.notify({
          title: this.$t('USER_INTEGRATION.attention'),
          text: this.$t('USER_INTEGRATION.fieldRequired', { field: this.$t('USER_INTEGRATION.role') }),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }

      return true
    },
    validateEditForm() {
      if (this.editIntegrationUserData.name === '' || this.editIntegrationUserData.name === null) {
        this.$vs.notify({
          title: this.$t('USER_INTEGRATION.attention'),
          text: this.$t('USER_INTEGRATION.fieldRequired', { field: this.$t('USER_INTEGRATION.name') }),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }

      if (JSON.stringify(this.editIntegrationUserData.role) === '{}') {
        this.$vs.notify({
          title: this.$t('USER_INTEGRATION.attention'),
          text: this.$t('USER_INTEGRATION.fieldRequired', { field: this.$t('USER_INTEGRATION.role') }),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }

      return true
    },
    async confirmRefreshUserToken(rowHash) {
      this.rowHashToRefresh = rowHash
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: this.$t('USER_INTEGRATION.confirmReset'),
        text: this.$t('USER_INTEGRATION.resetTokenConfirmation'),
        accept: this.refreshUserToken,
        acceptText: this.$t('USER_INTEGRATION.reset')
      })

    },
    async refreshUserToken() {

      this.$vs.loading({ type: 'default' })

      // await fetch(`${this.$store.state.auth.api_url}`, {
      //   method: 'POST', headers: {"Content-Type": "application/json"},
      //   headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: 'refresh_application_integration_user_token',
      //     parameters: {
      //       application_token: this.$store.state.auth.app_token,
      //       session_token: this.$store.state.auth.token,
      //       user_hash: this.rowHashToRefresh
      //     }
      //   })
      // })
      await performFetch(this.$store.state.auth.api_url, {
        command: 'refresh_application_integration_user_token',
        parameters: {
          application_token: this.$store.state.auth.app_token,
          session_token: this.$store.state.auth.token,
          user_hash: this.rowHashToRefresh
        }
      })
        .then(async (response) => {
          if (response.status === 200) {
            response.json().then(async (response) => {

              this.getIntegrationUsers()
              this.$vs.notify({
                title: this.$t('USER_INTEGRATION.operationPerformed'),
                text: this.$t('USER_INTEGRATION.tokenUpdated'),
                iconPack: 'feather',
                icon: 'icon-check',
                color: 'success'
              })

            })
          } else if (response.status == 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          } else {
            //this.$vs.loading.close()
          }
        })
        .catch((e) => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Operação não realizada!',
            text: e.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          throw new Error(e.message)
        })

      this.rowHashToRefresh = ''

    },
    async addIntegrationUser() {

      if (!this.validateAddForm()) {
        return
      }

      this.$vs.loading({ type: 'default' })

      let dashboardRoles = []

      // await fetch(`${this.$store.state.auth.api_url}`, {
      //   method: 'POST', headers: {"Content-Type": "application/json"},
      //   headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: 'add_application_integration_user',
      //     parameters: {
      //       application_token: this.$store.state.auth.app_token,
      //       session_token: this.$store.state.auth.token,
      //       user: {
      //         name: this.addIntegrationUserData.name,
      //         role: this.addIntegrationUserData.role.hash
      //       }
      //     }
      //   })
      // })
      await performFetch(this.$store.state.auth.api_url, {
        command: 'add_application_integration_user',
        parameters: {
          application_token: this.$store.state.auth.app_token,
          session_token: this.$store.state.auth.token,
          user: {
            name: this.addIntegrationUserData.name,
            role: this.addIntegrationUserData.role.hash
          }
        }
      })
        .then((response) => {
          if (response.status === 200) {
            response.json().then(responseData => {
              this.addIntegrationUserData.apiToken = responseData.data.token
              this.$vs.loading.close()
              this.$vs.notify({
                title: this.$t('USER_INTEGRATION.operationPerformed'),
                text: this.$t('USER_INTEGRATION.dashboardAdded'),
                iconPack: 'feather',
                icon: 'icon-check',
                color: 'success'
              })
            })
          } else if (response.status === 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          }
        })
        .catch((e) => {
          console.log(e)
          this.$vs.loading.close()
          this.$vs.notify({
            title: this.$t('USER_INTEGRATION.attention'),
            text: e.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          throw new Error(e.message)
        })
    },
    async updateIntegrationUser() {

      if (!this.validateEditForm()) {
        return
      }

      this.$vs.loading({ type: 'default' })

      // await fetch(`${this.$store.state.auth.api_url}`, {
      //   method: 'POST', headers: {"Content-Type": "application/json"},
      //   headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: 'update_application_integration_user',
      //     parameters: {
      //       application_token: this.$store.state.auth.app_token,
      //       session_token: this.$store.state.auth.token,
      //       user: {
      //         hash: this.editIntegrationUserData.hash,
      //         name: this.editIntegrationUserData.name,
      //         role: this.editIntegrationUserData.role
      //       }
      //     }
      //   })
      // })
      await performFetch(this.$store.state.auth.api_url, {
        command: 'update_application_integration_user',
        parameters: {
          application_token: this.$store.state.auth.app_token,
          session_token: this.$store.state.auth.token,
          user: {
            hash: this.editIntegrationUserData.hash,
            name: this.editIntegrationUserData.name,
            role: this.editIntegrationUserData.role
          }
        }
      })
        .then((response) => {
          if (response.status === 200) {
            this.getIntegrationUsers()
            this.editIntegrationUserPopUpActive = false
            this.clearEditForm()
            this.$vs.notify({
              title: this.$t('USER_INTEGRATION.operationPerformed'),
              text: this.$t('USER_INTEGRATION.dashboardUpdated'),
              iconPack: 'feather',
              icon: 'icon-check',
              color: 'success'
            })
          } else if (response.status === 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          }
        })
        .catch((e) => {
          console.log(e)
          this.$vs.loading.close()
          this.$vs.notify({
            title: this.$t('USER_INTEGRATION.attention'),
            text: e.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          throw new Error(e.message)
        })
    },
    async viewIntegrationUserDetail(userHash) {
      // await fetch(`${this.$store.state.auth.api_url}`, {
      //   method: 'POST', headers: {"Content-Type": "application/json"},
      //   headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: 'get_application_integration_user_detail',
      //     parameters: {
      //       application_token: this.$store.state.auth.app_token,
      //       session_token: this.$store.state.auth.token,
      //       user_hash: userHash
      //     }
      //   })
      // })
      await performFetch(this.$store.state.auth.api_url, {
        command: 'get_application_integration_user_detail',
        parameters: {
          application_token: this.$store.state.auth.app_token,
          session_token: this.$store.state.auth.token,
          user_hash: userHash
        }
      })
        .then((response) => {
          if (response.status === 200) {
            response.json().then((responseData) => {

              // this.viewDashboardData.name = responseData.dashboard.name
              // this.viewDashboardData.description = responseData.dashboard.description
              // this.viewDashboardData.roles = responseData.dashboard.roles
              // this.viewDashboardData.refreshInterval = this.refreshIntervalOptions.find(x => x.value === responseData.dashboard.refresh_interval)
              this.viewIntegrationUserData.name = responseData.user.name
              this.viewIntegrationUserData.role = responseData.user.role
              this.viewIntegrationUserData.apiToken = responseData.user.api_token

              this.viewIntegrationUserPopUpActive = true

              this.$vs.loading.close()
            })
              .catch(e => {
                console.log(e)
                this.$vs.loading.close()
                this.$vs.notify({
                  title: this.$t('USER_INTEGRATION.attention'),
                  text: e.message,
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'danger'
                })
                throw new Error(e.message)
              })
          } else if (response.status === 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          }
        })
        .catch((e) => {
          console.log(e)
          this.$vs.loading.close()
          this.$vs.notify({
            title: this.$t('USER_INTEGRATION.attention'),
            text: e.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          throw new Error(e.message)
        })
    },
    async getIntegrationUserDetail(userHash) {
      // await fetch(`${this.$store.state.auth.api_url}`, {
      //   method: 'POST', headers: {"Content-Type": "application/json"},
      //   headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: 'get_application_integration_user_detail',
      //     parameters: {
      //       application_token: this.$store.state.auth.app_token,
      //       session_token: this.$store.state.auth.token,
      //       user_hash: userHash
      //     }
      //   })
      // })
      await performFetch(this.$store.state.auth.api_url, {
        command: 'get_application_integration_user_detail',
        parameters: {
          application_token: this.$store.state.auth.app_token,
          session_token: this.$store.state.auth.token,
          user_hash: userHash
        }
      })
        .then((response) => {
          if (response.status === 200) {
            response.json().then((responseData) => {

              this.editIntegrationUserData.hash = responseData.user.hash
              this.editIntegrationUserData.name = responseData.user.name
              this.editIntegrationUserData.role = responseData.user.role

              this.editIntegrationUserPopUpActive = true

              this.$vs.loading.close()
            })
              .catch(e => {
                console.log(e)
                this.$vs.loading.close()
                this.$vs.notify({
                  title: this.$t('USER_INTEGRATION.attention'),
                  text: e.message,
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'danger'
                })
                throw new Error(e.message)
              })
          } else if (response.status === 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          }
        })
        .catch((e) => {
          console.log(e)
          this.$vs.loading.close()
          this.$vs.notify({
            title: this.$t('USER_INTEGRATION.attention'),
            text: e.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          throw new Error(e.message)
        })
    },
    confirmDeleteRecord(rowHash) {
      this.rowHashToDelete = rowHash
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: this.$t('USER_INTEGRATION.confirmDeletionTitle'),
        text: this.$t('USER_INTEGRATION.confirmDeletionText'),
        accept: this.deleteRecord,
        acceptText: this.$t('USER_INTEGRATION.delete')
      })
    },
    async deleteRecord() {

      this.$vs.loading({ type: 'default' })

      // fetch(`${this.$store.state.auth.api_url}`, {
      //   method: 'POST', headers: {"Content-Type": "application/json"},
      //   headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: 'delete_application_integration_user',
      //     parameters: {
      //       application_token: this.$store.state.auth.app_token,
      //       session_token: this.$store.state.auth.token,
      //       dashboard_hash: this.rowHashToDelete
      //     }
      //   })
      // })
      await performFetch(`${this.$store.state.auth.api_url}`, {
        command: 'delete_application_integration_user',
        parameters: {
          application_token: this.$store.state.auth.app_token,
          session_token: this.$store.state.auth.token,
          dashboard_hash: this.rowHashToDelete
        }
      })
        .then(async (response) => {
          if (response.status === 200) {
            response.json().then(async (response) => {

              this.getIntegrationUsers()
              this.$vs.notify({
                title: this.$t('USER_INTEGRATION.operationPerformed'),
                text: this.$t('USER_INTEGRATION.userDeleted'),
                iconPack: 'feather',
                icon: 'icon-check',
                color: 'success'
              })

            })
          } else if (response.status == 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          } else {
            //this.$vs.loading.close()
          }
        })
        .catch((e) => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: this.$t('USER_INTEGRATION.attention'),
            text: e.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          throw new Error(e.message)
        })

      this.rowHashToDelete = ''
    },
    async getIntegrationUsersParameters() {
      this.$vs.loading({ type: 'default' })
      // await fetch(`${this.$store.state.auth.api_url}`, {
      //   method: 'POST', headers: {"Content-Type": "application/json"},
      //   headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: 'get_application_user_parameters',
      //     parameters: {
      //       application_token: this.$store.state.auth.app_token,
      //       session_token: this.$store.state.auth.token
      //     }
      //   })
      // })
      await performFetch(this.$store.state.auth.api_url, {
        command: 'get_application_user_parameters',
        parameters: {
          application_token: this.$store.state.auth.app_token,
          session_token: this.$store.state.auth.token
        }
      })
        .then((response) => {
          if (response.status === 200) {
            response.json().then((responseData) => {

              this.rolesOptions = []

              responseData.parameters.roles.forEach(item => {
                this.rolesOptions.push({
                  hash: item.hash,
                  name: item.name
                })
              })

              this.$vs.loading.close()
            })
              .catch(e => {
                console.log(e)
                this.$vs.loading.close()
                this.$vs.notify({
                  title: this.$t('USER_INTEGRATION.attention'),
                  text: e.message,
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'danger'
                })
                throw new Error(e.message)
              })
          } else if (response.status === 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          }
        })
        .catch((e) => {
          console.log(e)
          this.$vs.loading.close()
          this.$vs.notify({
            title: this.$t('USER_INTEGRATION.attention'),
            text: e.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          throw new Error(e.message)
        })
    },
    async getIntegrationUsers() {
      this.$vs.loading({ type: 'default' })
      // await fetch(`${this.$store.state.auth.api_url}`, {
      //   method: 'POST', headers: {"Content-Type": "application/json"},
      //   headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: 'get_application_integration_users',
      //     parameters: {
      //       application_token: this.$store.state.auth.app_token,
      //       session_token: this.$store.state.auth.token
      //     }
      //   })
      // })
      await performFetch(this.$store.state.auth.api_url, {
        command: 'get_application_integration_users',
        parameters: {
          application_token: this.$store.state.auth.app_token,
          session_token: this.$store.state.auth.token
        }
      })
        .then((response) => {
          if (response.status === 200) {
            response.json().then((responseData) => {

              this.integrationUsers = []

              if (responseData.users.length > 0) {
                responseData.users.forEach((item) => {

                  const userRow = {
                    hash: item.hash,
                    name: item.name,
                    role: item.role,
                    api_token: item.api_token
                  }

                  this.integrationUsers.push(userRow)
                })
              }

              this.$vs.loading.close()
            })
              .catch(e => {
                console.log(e)
                this.$vs.loading.close()
                this.$vs.notify({
                  title: this.$t('USER_INTEGRATION.attention'),
                  text: e.message,
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'danger'
                })
                throw new Error(e.message)
              })
          } else if (response.status === 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          }
        })
        .catch((e) => {
          console.log(e)
          this.$vs.loading.close()
          this.$vs.notify({
            title: this.$t('USER_INTEGRATION.attention'),
            text: e.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          throw new Error(e.message)
        })
    }
  },
  async created() {
    await this.getIntegrationUsersParameters()
    await this.getIntegrationUsers()
  }
}
</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>
